import * as Tooltip from "@radix-ui/react-tooltip";
import React, { useState } from "react";
import styles from "./CheckboxWithTooltip.module.css";

interface InfoTooltipProps {
  tooltipLabel: string;
  tooltipContent: string;
  disabled?: boolean;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  tooltipLabel,
  tooltipContent,
  disabled = false,
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleTooltipClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsTooltipOpen(true);
  };

  return (
    <Tooltip.Root open={isTooltipOpen} onOpenChange={setIsTooltipOpen}>
      <Tooltip.Trigger asChild>
        <button
          className={styles["info-button"]}
          disabled={disabled}
          onClick={handleTooltipClick}
          aria-label="Show more information"
        >
          ℹ
        </button>
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content className={styles["tooltip-content"]} sideOffset={5}>
          <p>
            <strong>{tooltipLabel}</strong>
          </p>
          <p>{tooltipContent}</p>
          <Tooltip.Arrow style={{ fill: "white" }} />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
};

export default InfoTooltip;
